import { render, staticRenderFns } from "./bysdetail.vue?vue&type=template&id=f2f6613c&scoped=true&"
import script from "./bysdetail.vue?vue&type=script&lang=js&"
export * from "./bysdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f6613c",
  null
  
)

export default component.exports